<div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoBeneficio">
        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill *ngFor="let uniforme of aluno.uniformes; let index = index;">
            <fieldset class="bordas" fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                    <mat-select [(ngModel)]="uniforme.tamanhoUniforme" [ngModelOptions]="{standalone: true}" name="tamanhoUniforme_{{idRandomico}}" placeholder="Tamanho:" >
                        <mat-option *ngFor="let m of tamanhoUniforme.tamanho" [value]="m.sigla">
                            {{ m.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <input matInput [ngModelOptions]="{standalone: true}"
                        maxlength="10" [(ngModel)]="uniforme.qtdUniformeEntregue" pattern="[0-9]+$"
                        style="text-align: center" required placeholder="Quantidade:">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="dataUniformeEntregue" [max]="maxDate" [ngModelOptions]="{standalone: true}" (input)="onMascaraDataInput($event)"
                        [min]="minDate" [matDatepicker]="datareferencia" [(ngModel)]="uniforme.dataUniformeEntregue" placeholder="Data da Entrega:">
                    <mat-datepicker-toggle matSuffix [for]="datareferencia"></mat-datepicker-toggle>
                    <mat-datepicker #datareferencia></mat-datepicker>
                </mat-form-field>
                
                <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletarUniformePorAlunoEUnidade(index)">
                    <mat-icon>delete</mat-icon>
                </button>
            </fieldset>
        </div>
        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
            style="padding-top: 10px; padding-left: 20px; padding-bottom: 10px;">
            <div>
                <button type="button" matTooltip="Novo" mat-mini-fab color="primary" (click)="adicionarUniformePorAlunoEUnidade()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>